// extracted by mini-css-extract-plugin
module.exports = {"red":"countCircle_red__71sL5","countCircle":"countCircle_countCircle__1H-JE"};